"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferOwnershipButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const transferOwnership_json_1 = __importDefault(require("@framework/abis/json/Ownable/transferOwnership.json"));
const dialogs_1 = require("../../../dialogs");
const validation_1 = require("../../../dialogs/account/validation");
const TransferOwnershipButton = (props) => {
    const { className, contract, contract: { address, contractSecurity }, disabled, variant, } = props;
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const { execute: metaFn } = (0, react_hooks_eth_1.useMetamask)(async (values) => {
        return writeContractAsync({
            address: address,
            abi: transferOwnership_json_1.default,
            functionName: "transferOwnership",
            args: [values.account],
        });
    });
    const handleTransferOwnershipConfirm = async ({ data }) => {
        await metaFn(data);
    };
    const handleTransferOwnership = () => {
        openDialog(dialogs_1.GlobalDialogKeys.ACCOUNT, contract, {
            initialValues: {
                account: "",
            },
            validationSchema: validation_1.accountDialogValidationSchema,
            message: "dialogs.transferOwnership",
            testId: "TransferOwnershipForm",
            onExternalConfirm: handleTransferOwnershipConfirm,
        });
    };
    // Check the ownership in blockchain? or where to see this information in DB?
    if (contractSecurity !== types_1.ContractSecurity.OWNABLE) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleTransferOwnership, icon: icons_material_1.ChangeCircle, message: "form.buttons.transferOwnership", className: className, dataTestId: "TransferOwnershipButton", disabled: disabled, variant: variant }));
};
exports.TransferOwnershipButton = TransferOwnershipButton;
//# sourceMappingURL=index.js.map